<template>
  <div id="intro-3" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Personalize</h3>
      </div>

      <div class="intro-box__content">
        <p>Why don't you personalize your dashboard?</p>

        <div class="intro-box__actions">
          <div class="form-field">
            <div class="grid-x grid-padding-x">
              <div class="cell shrink">
                <label style="width: 100%;">App Theme</label>
              </div>

              <div class="cell auto">
                <label :class="['radio-choice', theme === 'light' ? 'active' : '']" for="theme-light"
                       style="background: #fff; color: #333;" @click="changeTheme('light')">Light
                  <input id="theme-light" class="hidden" type="radio" name="theme"
                         value="light">
                </label>

                <label :class="['radio-choice', theme === 'dark' ? 'active' : '']" for="theme-dark"
                       style="background: #333; color: #fff;" @click="changeTheme('dark')">Dark
                  <input id="theme-dark" class="hidden" type="radio" name="theme"
                         value="dark" checked="checked">
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="intro-box__footer">
      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <button class="button--wide button--alt" @click="changeStep(false)">Back</button>
        </div>

        <div class="cell auto">
          <button :class="['button--wide', chosen === null ? 'disabled': '']" @click="changeStep">
            Next
          </button>
        </div>
      </div>

<!--      <div class="intro-box__skip">configure later</div>-->
    </div>

    <div class="intro-box__pagination">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span class="active"></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [
    client
  ],
  data: function () {
    return {
      theme: 'light'
    }
  },
  methods: {
    changeTheme (theme) {
      this.theme = theme
      let body = document.getElementsByTagName('body')[0]

      if (theme === 'light') {
        body.classList.add('light-theme')
      } else {
        body.classList.remove('light-theme')
      }

      this.request('put', '/settings/settings/' + this.settings.id + '/retrieve-update/', {
        theme: theme
      })
    },
    changeStep (next = true) {
      this.$emit('changeStep', next)
    }
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step7.vue